import type { StatusVariant } from '../shared/StatusChip'

/**
 * LegiScan status labels are free text ("Passed House", "In committee", "Failed", …), not an
 * enum — this is a best-effort keyword match onto the app's fixed status vocabulary. Shared by
 * BillLinkModal (link management) and LinkedBillDetailSheet (organizer read-only view) so both
 * colour a bill's status identically.
 */
export function billStatusVariant(label: string | null): StatusVariant {
  if (!label) return 'neutral'
  const l = label.toLowerCase()
  if (/(fail|dead|veto(?!d)|died)/.test(l)) return 'danger'
  if (/(pass|enact|signed|adopt)/.test(l)) return 'success'
  if (/(committee|pending|introduc|referred)/.test(l)) return 'info'
  return 'neutral'
}
